import { AxiosPromise } from 'axios';
import axios from 'axios';
import { ICopyScheduleReq, IGetBus, IGetBuses, IGetLine, IGetLines, IGetSchedule, IGetSchedules, IGetStationTimes, IGetStudents, IGetStudents2, ILineReq, IScheduleReq, IStationReq, IStationTimeReq, IStudentReq } from '../models/shuttleSetting.model';

const uri = '/mgmt/shuttle-setting';

export const getBuses = (campusCode: string): AxiosPromise<IGetBuses> => {
  return axios.get(`${uri}/${campusCode}/buses`);
};

export const getBus = (campusCode: string, busCode: number): AxiosPromise<IGetBus> => {
  return axios.get(`${uri}/${campusCode}/buses/${busCode}`);
};

export const createBus = (campusCode: string, data: any): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/buses`, data);
};

export const updateBus = (campusCode: string, busCode: number, data: any): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/buses/${busCode}`, data);
};

export const getLines = (campusCode: string): AxiosPromise<IGetLines> => {
  return axios.get(`${uri}/${campusCode}/lines`);
};

export const getLine = (campusCode: string, lineCode: number): AxiosPromise<IGetLine> => {
  return axios.get(`${uri}/${campusCode}/lines/${lineCode}`);
};

export const createLine = (campusCode: string, data: ILineReq): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/lines`, data);
};

export const updateLine = (campusCode: string, data: ILineReq): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/lines`, data);
};

export const deleteLine = (campusCode: string, data: ILineReq): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/lines/delete`, data);
};

export const updateStations = (campusCode: string, lineCode: number, data: IStationReq[]): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/lines/${lineCode}`, data);
};

export const deleteStation = (campusCode: string, lineCode: number, stationCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${campusCode}/lines/${lineCode}/${stationCode}`);
};

export const getSchedules = (campusCode: string, lineCode: number, weekdayDiv: string): AxiosPromise<IGetSchedules> => {
  return axios.get(`${uri}/${campusCode}/running/${lineCode}/${weekdayDiv}`);
};

export const getSchedule = (campusCode: string, runningCode: number): AxiosPromise<IGetSchedule> => {
  return axios.get(`${uri}/${campusCode}/line-info/${runningCode}`);
};

export const getStationTimes = (campusCode: string, runningCode: number): AxiosPromise<IGetStationTimes> => {
  return axios.get(`${uri}/${campusCode}/running/${runningCode}/station-info`);
};

export const createSchedule = (campusCode: string, lineCode: number, data: IScheduleReq): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/running/${lineCode}`, data);
};

export const updateSchedule = (campusCode: string, lineCode: number, weekdayDiv: string, data: IScheduleReq): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/running/${lineCode}/${weekdayDiv}`, data);
};

export const deleteSchedule = (campusCode: string, runningCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${campusCode}/running/remove/${runningCode}`);
};

export const copySchedule = (campusCode: string, data: ICopyScheduleReq[]): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/running/copy`, data);
};

export const createStationTime = (campusCode: string, runningCode: number, data: IStationTimeReq[]): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/running/station-time/${runningCode}`, data);
};

export const updateStationTime = (campusCode: string, runningCode: number, data: IStationTimeReq[]): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/running/station-time/modify/${runningCode}`, data);
};

export const getStudents = (campusCode: string, runningStationCode: number): AxiosPromise<IGetStudents> => {
  return axios.get(`${uri}/${campusCode}/running/station/${runningStationCode}`);
};

export const getStudentList = (campusCode: string, semesterCode: number): AxiosPromise<IGetStudents2> => {
  return axios.get(`${uri}/${campusCode}/running/station/student-list/${semesterCode}`);
};

export const createStudents = (campusCode: string, runningStationCode: number, data: IStudentReq[]): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/running/station/${runningStationCode}`, data);
};

export const deleteStudent = (campusCode: string, rideStudentCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${campusCode}/running/station/student/${rideStudentCode}`);
};
